import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Col, Row, Tooltip } from 'antd';
import { GeneralInformationPanel, InputRenderer, CompareContractButton } from '..';
import { useAppStore } from '../../stores';
import { InputBaseModel } from '../../models';
import { ClickableIcon } from '../../../common/components';
import { SearchIcon } from '../../../custom_shared/icons';
import { InputIds, NodeIds, StyleUtils } from '../../misc';
import { InputComponentRegistry } from '../../node_inputs';

const InputComponents = InputComponentRegistry[NodeIds.GeneralInformation];

interface Props {
    businessIdInput: InputBaseModel;
    expiringPeriodStartInput: InputBaseModel;
    panelName: string;
    panelKey: string;
    addRef: (panelKey: string, ref: React.RefObject<HTMLDivElement>) => void;
}

const BasicRenewalPanelRenderer: React.FC<Props> = ({
    businessIdInput,
    expiringPeriodStartInput,
    panelName,
    panelKey,
    addRef
}) => {
    const { businessSearchStore, contractSubmissionStore } = useAppStore();

    return (
        <GeneralInformationPanel panelKey={panelKey} panelName={panelName} addRef={addRef}>
            <Row gutter={10}>
                <Col style={StyleUtils.getNodeColumnStyle(8)}>
                    <InputRenderer
                        input={businessIdInput}
                        component={InputComponents[InputIds.GeneralInformation.BusinessId]}
                    />
                </Col>

                <Col style={StyleUtils.getNodeColumnStyle(8)}>
                    <InputRenderer
                        input={expiringPeriodStartInput}
                        component={InputComponents[InputIds.GeneralInformation.ExpiringPeriodStart]}
                    />
                </Col>

                <Col style={{ ...StyleUtils.getNodeColumnStyle(8), alignItems: 'center', gap: 10 }}>
                    {!contractSubmissionStore.contractSendingOrSent && (
                        <>
                            {businessSearchStore.isBusinessSearchSupported && (
                                <Tooltip title="Business Search">
                                    <ClickableIcon
                                        icon={SearchIcon}
                                        width={24}
                                        height={24}
                                        onClick={() => {
                                            businessSearchStore.initializeSearchModal(
                                                businessIdInput,
                                                expiringPeriodStartInput
                                            );
                                        }}
                                    />
                                </Tooltip>
                            )}
                        </>
                    )}
                </Col>
            </Row>

            {!contractSubmissionStore.contractSendingOrSent && (
                <CompareContractButton businessIdInput={businessIdInput} />
            )}
        </GeneralInformationPanel>
    );
};

export default observer(BasicRenewalPanelRenderer);
